var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.05556 5.90909H7.94444V4.13636C7.94444 3.4839 7.70573 2.92685 7.2283 2.4652C6.75087 2.00355 6.17477 1.77273 5.5 1.77273C4.82523 1.77273 4.24913 2.00355 3.7717 2.4652C3.29427 2.92685 3.05556 3.4839 3.05556 4.13636V5.90909ZM11 6.79545V12.1136C11 12.3598 10.9109 12.5691 10.7326 12.7415C10.5544 12.9138 10.338 13 10.0833 13H0.916667C0.662037 13 0.445602 12.9138 0.267361 12.7415C0.0891204 12.5691 0 12.3598 0 12.1136V6.79545C0 6.54924 0.0891204 6.33996 0.267361 6.16761C0.445602 5.99526 0.662037 5.90909 0.916667 5.90909H1.22222V4.13636C1.22222 3.00379 1.64236 2.03125 2.48264 1.21875C3.32292 0.40625 4.3287 0 5.5 0C6.6713 0 7.67708 0.40625 8.51736 1.21875C9.35764 2.03125 9.77778 3.00379 9.77778 4.13636V5.90909H10.0833C10.338 5.90909 10.5544 5.99526 10.7326 6.16761C10.9109 6.33996 11 6.54924 11 6.79545Z",
    fill: "#545454"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon_lock.5a5734258e14d49af6d3e6bf2c30001a.svg";
export { ForwardRef as ReactComponent };